import { useEffect } from 'react';
import Cookies from 'js-cookie';

const ACCESSIBLE_ID = 'accessibility-widget-container';
const ACCESSIBLE_SESSION = 'accessibilityWidget';

const COOKIE_ID = 'cookie-information-template-wrapper';

// use-effect
const MAX_WAIT = 3000;
const POLL_INTERVAL = 500;

export const useGTMWidgets = () => {
  const hideCookie = () => {
    const cookieId = document.getElementById(COOKIE_ID);
    if (cookieId && cookieId?.style.display !== 'none')
      cookieId.style.display = 'none';
  };

  const showCookie = () => {
    const cookieId = document.getElementById(COOKIE_ID);
    if (cookieId?.style.display === 'none') cookieId.style.display = 'inherit';
    (window as any).CookieConsent?.renew();
  };

  const hideAccessibility = () => {
    sessionStorage.removeItem(ACCESSIBLE_SESSION);
    const accessibleId = document.getElementById(ACCESSIBLE_ID);
    if (accessibleId && accessibleId?.style.display !== 'none')
      accessibleId.style.display = 'none';
  };

  const showAccessibility = () => {
    sessionStorage.setItem(ACCESSIBLE_SESSION, 'true');
    const accessibleId = document.getElementById(ACCESSIBLE_ID);
    if (accessibleId) accessibleId.style.display = 'inherit';
    (window as any).AccessibilityWidget?.show();
  };

  // Hide widgets by default as soon as their elements appear (max 3s)
  useEffect(() => {
    let elapsed = 0;
    let cookieHidden = false;
    let accessibleHidden = false;

    const timer = setInterval(() => {
      elapsed += POLL_INTERVAL;

      const clientCookiesAlreadyDefined = Boolean(
        Cookies.get('CookieInformationConsent'),
      );
      if (
        !cookieHidden &&
        document.getElementById(COOKIE_ID) &&
        clientCookiesAlreadyDefined
      ) {
        cookieHidden = true;
        hideCookie();
      }

      if (!accessibleHidden && document.getElementById(ACCESSIBLE_ID)) {
        accessibleHidden = true;
        hideAccessibility();
      }

      const allWidgetsHidden = cookieHidden && accessibleHidden;
      if (allWidgetsHidden || elapsed >= MAX_WAIT) {
        clearInterval(timer);
      }
    }, POLL_INTERVAL);

    return () => clearInterval(timer);
  }, [window.location.pathname]);

  return {
    showAccessibility,
    showCookie,
  };
};
